import { Link } from "@tanstack/react-router";
import { useServerFn } from "@tanstack/react-start";
import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/lib/auth-context";
import {
  getUniverseLeaderboard,
  type UniverseResponse,
} from "@/lib/universe.functions";

/**
 * Site-wide footer. Compact on mobile, slightly roomier on larger screens.
 * Rendered on every page via the root layout.
 */
export function SiteFooter() {
  const year = new Date().getFullYear();
  const { session } = useAuth();
  const fetchUniverse = useServerFn(getUniverseLeaderboard);

  // Only signed-in users can hit /universe. Reuse the cached query so the
  // footer link appears/disappears in lockstep with the inline card and
  // costs nothing on pages that already fetch it.
  const { data: universe } = useQuery<UniverseResponse>({
    queryKey: ["universe-leaderboard"],
    queryFn: () => fetchUniverse(),
    staleTime: 60_000,
    enabled: !!session,
  });

  return (
    <footer className="mt-auto border-t border-border bg-background/50">
      <div className="mx-auto flex max-w-[1400px] flex-col items-center justify-between gap-2 px-4 py-3 text-[11px] text-muted-foreground sm:flex-row sm:py-4 sm:text-xs">
        <p className="text-center sm:text-left">
          © {year} Bracket Goblin
        </p>
        <nav className="flex items-center gap-4">
          {universe?.available && (
            <Link
              to="/universe"
              className="hover:text-foreground hover:underline"
            >
              Site-wide leaderboard
            </Link>
          )}
          <Link
            to="/privacy"
            className="hover:text-foreground hover:underline"
          >
            Privacy Policy
          </Link>
        </nav>
      </div>
    </footer>
  );
}
